<template>
  <div class="surface-design-color">
    <TopPanel
      @search="surfaceDesignColorsStore.searchByItems($event, $route.params.id)"
      @sort-order="surfaceDesignColorsStore.setSortOrderItems($event, $route.params.id)"
      @sort-option="surfaceDesignColorsStore.sortItems($event, $route.params.id)"
      backLink="/user/surface-design-colors"
      backText="Back to all colors"
      :sort-options="sortOptions"
      :title="surfaceDesignColorsStore.selectedCollectionName"
      :needExtra="false"
      :create="false"
      @rename="editModal"
      @del="delModal"
      @edit="$router.push('/user/surface-design-colors-new')"
    />
    <ButtonsGroup class="standart">
      <button
        :class="mode === 'hex' ? 'active' : ''"
        @click="mode = 'hex'"
      >
        HEX
      </button>
      <button
        :class="mode === 'rgb' ? 'active' : ''"
        @click="mode = 'rgb'"
      >
        RGB
      </button>
    </ButtonsGroup>
    <EmptyGrid v-if="surfaceDesignColorsStore.itemsCount === 0" @create-new="createNewItem"
      :buttonPlusIcon="false" :buttonEditIcon="true">
      <template v-slot:icon>
        <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 32 32">
          <path d="M8.7 28.7c-.5 0-.9-.1-1.4-.2-2.9-.8-4.6-3.7-3.8-6.6l4.8-18c.1-.4.3-.7.7-.9.3-.1.7-.2 1-.1l7.7 2c.4.1.7.3.9.7.2.3.2.7.1 1.1l-4.8 18c-.6 2.5-2.8 4-5.2 4zm1-24.3-4.8 18c-.3 1-.1 2.1.4 3 .5.9 1.4 1.6 2.4 1.8 2.1.6 4.2-.7 4.8-2.8l4.8-18-7.6-2z" />
          <path d="M27.3 28.8H8.7c-.4 0-.8-.3-.8-.8s.3-.8.8-.8h18.6v-7.9c0-.4.3-.8.8-.8s.8.3.8.8v7.9c-.2.9-.8 1.6-1.6 1.6zM8.7 24.2c-.2 0-.3-.1-.5-.2-.3-.3-.4-.7-.1-1.1.1-.2.4-.3.6-.3.3 0 .6.2.7.5v.3c0 .2-.1.3-.2.5s-.3.3-.5.3z" class="st0"/>
          <path d="M10.6 28.3c-.3 0-.6-.2-.7-.4-.2-.4 0-.8.4-1L27.2 19l-3.4-7.1-7.5 3.5c-.4.2-.8 0-1-.4-.2-.4 0-.8.4-1l7.5-3.5c.7-.3 1.6 0 1.9.7l3.3 7.2c.3.7 0 1.6-.7 1.9L11 28.2c-.1.1-.3.1-.4.1z" />
        </svg>
      </template>
      <template v-slot:title>This palette is empty</template>
      <template v-slot:text>Click “Edit” button to add colors</template>
      <template v-slot:button-text>Edit palette</template>
    </EmptyGrid>
    <div v-else class="items">
      <div  class="item" v-for="item in surfaceDesignColorsStore.items" :key="item.id">
        <div :style="item.hex ? `background-color:${item.hex}` : ''" class="color-container">
          <p>{{mode === 'hex' ? item.hex : item.rgb}}</p>
        </div>
        <p class="name" v-if="item.name">{{item.name}}</p>
      </div>
    </div>
    <PaginationComponent
      :limit="surfaceDesignColorsStore.itemsParams.limit"
      :offset="surfaceDesignColorsStore.itemsParams.offset"
      :total="surfaceDesignColorsStore.itemsCount"
      @setOffset="setOffset"
    />
    <ModalComponent @close="surfaceDesignColorsStore.renameModalToggle()" :show="surfaceDesignColorsStore.renameModal" >
      <template v-slot:icon>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="none" viewBox="0 0 32 32">
          <path d="M21.334 5.14a2.08 2.08 0 0 0-1.475.606l-4.39 4.39L4.803 20.804a.75.75 0 0 0-.219.531v5.332a.75.75 0 0 0 .75.75h5.332a.75.75 0 0 0 .531-.219L21.863 16.53l4.39-4.388a2.096 2.096 0 0 0 0-2.948l-3.446-3.447a2.076 2.076 0 0 0-1.473-.605zm0 1.49c.148 0 .295.06.412.177l3.447 3.447a.574.574 0 0 1 0 .826l-3.859 3.86-4.271-4.272 3.859-3.861a.581.581 0 0 1 .412-.176zM16 11.73 20.273 16l-9.918 9.916H6.084v-4.271L16 11.729z"/>
        </svg>
      </template>
      <template v-slot:title>Rename collection</template>
      <template v-slot:extra>
        <label class="edit-collection-field">
          <span>Collection Name</span>
          <input type="text" placeholder="" v-model="surfaceDesignColorsStore.collectionName">
        </label>
      </template>
      <template v-slot:buttons>
        <ButtonSecondary class="small" @click.native="surfaceDesignColorsStore.renameModalToggle()">Cancel</ButtonSecondary>
        <ButtonPrimary class="small" :disabled="surfaceDesignColorsStore.collectionName?.length === 0"
          @click.native="updateCollection">
          Rename
        </ButtonPrimary>
      </template>
    </ModalComponent>
    <ModalComponent @close="surfaceDesignColorsStore.delCollectionModalToggle()" type="error"
      :show="surfaceDesignColorsStore.delCollectionModal">
      <template v-slot:title>Delete collection</template>
      <template v-slot:description>Are you sure? You will lose the colors that are in it</template>
      <template v-slot:buttons>
        <ButtonSecondary class="small" @click.native="surfaceDesignColorsStore.delCollectionModalToggle()">
          Cancel
        </ButtonSecondary>
        <ButtonPrimary class="small" @click.native="deleteCollection">
          <template v-slot:icon>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="none" viewBox="0 0 21 20">
              <path d="M8 1.75c-.866 0-1.584.718-1.584 1.584v.916H3.834a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h.916v10.916c0 .866.718 1.584 1.584 1.584h8.332c.866 0 1.584-.718 1.584-1.584V5.75h.916a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75h-2.582v-.916c0-.866-.718-1.584-1.584-1.584H8zm0 1.5h5c.055 0 .084.03.084.084v.916H7.916v-.916c0-.055.03-.084.084-.084zm-1.75 2.5h8.5v10.916c0 .055-.03.084-.084.084H6.334c-.055 0-.084-.03-.084-.084V5.75z" color="#000" style="-inkscape-stroke:none"/>
            </svg>
          </template>
          Delete
        </ButtonPrimary>
      </template>
    </ModalComponent>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useSurfaceDesignColorsStore } from '@/store/pinia/surfaceDesignColors'

import TopPanel from '@/components/SurfaceDesign/TopPanel.vue'
import EmptyGrid from '@/components/Atoms/EmptyGrid.vue'
import ModalComponent from '@/components/Atoms/ModalComponent.vue'
import ButtonPrimary from '@/components/Atoms/ButtonPrimary.vue'
import ButtonSecondary from '@/components/Atoms/ButtonSecondary.vue'
import ButtonsGroup from '@/components/Atoms/ButtonsGroup.vue'
import PaginationComponent from '@/components/Atoms/PaginationComponentLimit.vue'

export default {
  name: 'UserCollection',
  components: {
    TopPanel,
    EmptyGrid,
    ModalComponent,
    ButtonPrimary,
    ButtonSecondary,
    ButtonsGroup,
    PaginationComponent,
  },
  computed: {
    ...mapStores(useSurfaceDesignColorsStore),
  },
  data: () => ({
    mode: 'hex',
    sortOptions: [
      { name: 'Sort by', value: '' },
      { name: 'Name', value: 'name' },
      { name: 'Updated', value: 'updatedAt' },
    ],
  }),
  methods: {
    async setOffset (offset) {
      this.surfaceDesignColorsStore.itemsParams.offset = offset
      const id = this.$route.params.id || this.surfaceDesignColorsStore.selectedCollectionId
      await this.surfaceDesignColorsStore.getItems(id)
    },
    deleteCollection () {
      this.surfaceDesignColorsStore.deleteCollection()
      this.$router.push('/user/surface-design-colors/')
    },
    delModal () {
      this.surfaceDesignColorsStore.delCollectionModalToggle()
      this.surfaceDesignColorsStore.collectionId = this.surfaceDesignColorsStore.selectedCollectionId
    },
    editModal () {
      this.surfaceDesignColorsStore.renameModalToggle()
      this.surfaceDesignColorsStore.collectionId = this.surfaceDesignColorsStore.selectedCollectionId
      this.surfaceDesignColorsStore.collectionName = this.surfaceDesignColorsStore.selectedCollectionName
    },
    updateCollection () {
      this.surfaceDesignColorsStore.selectedCollectionName = this.surfaceDesignColorsStore.collectionName
      this.surfaceDesignColorsStore.updateCollection()
    },
    createNewItem () {
      this.$router.push('/user/surface-design-colors-new/')
    },
  },
  async beforeMount () {
    const id = this.$route.params.id || this.surfaceDesignColorsStore.selectedCollectionId
    await Promise.all([
      this.surfaceDesignColorsStore.getItems(id),
      this.surfaceDesignColorsStore.getCollection(id),
    ])
  },
}
</script>

<style lang="scss">
.surface-design-color {
  padding: 0 16px 40px 40px;
  .buttons-group {
    max-width: 200px;
    margin-top: 18px;
  }
  .items {
    display: flex;
    gap: 40px;
    margin-top: 42px;
    text-align: center;
    flex-wrap: wrap;
    .name {
      overflow-wrap: break-word;
      max-width: 95px;
    }
    p {
      margin: 8px 0 0;
      font-size: 14px;
      color: var(--Text-Text_Primary);
    }
    .color-container {
      width: 95px;
      height: 95px;
      border-radius: 8px;
      border: 1px solid var(--Dividers);
      display: flex;
      align-items: center;
      justify-content: center;
      p {
        margin: 0;
        font-weight: 600;
      }
    }
  }
}
@media (max-width: 480px) {
  .surface-design-color {
    padding: 0;
    .buttons-group {
      max-width: 100%;
    }
  }
}
</style>
